import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SVG_ICONS } from "../../../models/icons";
import { SanitizerPipe } from "../../../pipes/sanitizer.pipe";
import { MasterService } from "../../../serivces/master.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { Cls_CenterData } from "../../../models/master";
import { GlobalService } from "../../../serivces/global.service";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { AsteriskMessageDirective } from "@frontend/app/directives/asterikmessage.directive";
import { MultiSelectDropdownComponent } from "@frontend/app/components/multi-select-dropdown/multi-select-dropdown.component";
import { AddAreaComponent } from "../../masters/add-area/add-area.component";
import { MatDialog } from "@angular/material/dialog";
import { AddRegionComponent } from "../../masters/add-region/add-region.component";

import { HttpClient } from "@angular/common/http";

type DocumentObject = {
  Category: string;
  FileName: string;
  MimeType: string;
  Base64: string;
};

@Component({
  selector: "app-create-center",
  imports: [CommonModule, SanitizerPipe, FormsModule, SharedModule, AsteriskMessageDirective, MultiSelectDropdownComponent],
  templateUrl: "./create-center.component.html",
  styleUrl: "./create-center.component.scss",
})
export class CreateCenterComponent implements OnInit, OnDestroy {
  private masterService = inject(MasterService);
  private globalService = inject(GlobalService);
  private toastService = inject(ToastrService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private http = inject(HttpClient);

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params["CenterID"] && params["CenterID"] > 0) {
        const CenterID = +params["CenterID"];
        this.centerData.CenterID = CenterID;
        this.getCenterDetailsByID();
      }
    });
    this.globalService.setIsShowFalse();
    this.getRegionList();
    this.getAreaList();
    // this.getCityList();
    this.getTrainerList();
  }

  //#region  variables
  step = 1;
  readonly SVG_ICONS = SVG_ICONS;
  centerData = new Cls_CenterData();
  regionList: any;
  areaList: any;
  allAreaList: any;
  trainerList: any;
  isRegionDropdownOpen = false;
  isAreaDropdownOpen = false;
  isCityDropdownOpen = false;
  RegionID = 0;
  AreaID = 0;
  CityID = 0;
  TrainerID = 0;
  ErrorMsg: any[] = [];
  uploadedDocuments: { [key: string]: DocumentObject[] } = {
    Profile: [],
  };
  @Input() documents: DocumentObject[] = [];
  userTypeID = sessionStorage.getItem("UserTypeID");

  //#endregion

  getRegionList() {
    this.masterService.getRegionList().subscribe((res: any) => {
      const { Table } = res;
      const storedIDs = sessionStorage.getItem("AllRegionIDs");
      const regionIDs: number[] = storedIDs ? JSON.parse(storedIDs) : [];
      if (this.userTypeID == "1") {
        this.regionList = Table;
      } else {
        this.regionList = Table.filter((item: any) => regionIDs.includes(item.RegionID) && item.IsActive);
      }
    });
  }

  // MODIFIED: This now populates the master list `allAreaList`
  getAreaList() {
    this.masterService.getAreaList().subscribe((res: any) => {
      const { Table } = res;
      const areas = sessionStorage.getItem("AllAreaIDs");
      const areaIDs: number[] = areas ? JSON.parse(areas) : [];
      this.allAreaList = Table;
    });
  }

  // NEW: This function is called when the region selection changes
  onRegionChange() {
    // 1. Clear any previously selected area
    this.centerData.AreaID = undefined; // Use null, undefined, or an empty array depending on what your dropdown component expects

    const selectedRegionId = this.centerData.RegionID;

    if (selectedRegionId) {
      // 2. Filter the master list to get areas for the selected region
      this.areaList = this.allAreaList.filter((area: any) => area.RegionID === selectedRegionId);
    } else {
      // 3. If no region is selected, ensure the area list is empty
      this.areaList = [];
    }
  }

  // getCityList() {
  //   this.masterService.getCityList().subscribe((res: any) => {
  //     const { data } = res;
  //     this.cityList = data.filter((item: any) => item.IsActive);
  //   });
  // }

  getTrainerList() {
    this.masterService.getCoachList().subscribe((res: any) => {
      const { Table } = res;
      const storedIDs = sessionStorage.getItem("AllCenterIDs");
      const centerIDs: number[] = storedIDs ? JSON.parse(storedIDs) : [];
      this.trainerList = Table.filter((item: any) => centerIDs.includes(item.CenterID));
    });
  }

  getCenterDetailsByID() {
    this.masterService.getCenterDetailsByID(this.centerData.CenterID).subscribe((res: any) => {
      this.centerData = res;

      // ✅ Ensure all lists are loaded before filtering
      if (this.allAreaList && this.allAreaList.length > 0) {
        this.setAreaListForRegion();
      } else {
        // If areaList not yet loaded, wait until it is
        const checkInterval = setInterval(() => {
          if (this.allAreaList && this.allAreaList.length > 0) {
            clearInterval(checkInterval);
            this.setAreaListForRegion();
          }
        }, 100);
      }
    });
  }

  private setAreaListForRegion() {
    this.areaList = this.allAreaList.filter((area: any) => area.RegionID === this.centerData.RegionID);

    // ✅ ensure dropdown selection is reflected properly
    setTimeout(() => {
      this.centerData.AreaID = this.centerData.AreaID;
    }, 0);
  }

  onAddArea() {
    this.dialog.open(AddAreaComponent, {
      width: "60%",
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getAreaList();
    });
  }
  onAddRegion() {
    this.dialog.open(AddRegionComponent, {
      width: "60%",
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getRegionList();
    });
  }
  nextStep() {
    this.step++;
  }

  previousStep() {
    this.step--;
  }

  validateForm(): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|net|org|in)$/;
    const mobilePattern = /^[0-9]{10}$/;
    const pincodePattern = /^[0-9]{6}$/;
    const requiredFields: {
      key: keyof Cls_CenterData;
      label: string;
      type?: "string" | "date" | "number" | "file";
    }[] = [
      { key: "CenterName", label: "Center Name", type: "string" },
      // { key: "Email", label: "Email", type: "string" },
      { key: "ContactNumber", label: "Contact Number", type: "string" },
      { key: "Address", label: "Address", type: "string" },
      { key: "District", label: "District", type: "string" },
      { key: "State", label: "State", type: "string" },
      { key: "Country", label: "Country", type: "string" },
      { key: "Pincode", label: "Pincode", type: "string" },
      { key: "ContactNumber", label: "Contact Number", type: "string" },
      // { key: "AlternateNumber", label: "Alternate Number", type: "string" },
    ];

    for (const field of requiredFields) {
      const value = this.centerData[field.key] as any;
      if (value == null || (typeof value === "string" && !value.trim())) {
        this.ErrorMsg.push(`${field.label}`);
        continue;
      }
      switch (field.key) {
        case "Email":
          if (!emailPattern.test(value)) {
            this.ErrorMsg.push(`Please enter a valid email address.`);
          }
          break;

        case "ContactNumber":
          // case "AlternateNumber":
          if (!mobilePattern.test(value)) {
            this.ErrorMsg.push(`${field.label} must be a 10-digit number.`);
          }
          break;

        case "Pincode":
          if (!pincodePattern.test(value)) {
            this.ErrorMsg.push(`${field.label} must be a 6-digit number.`);
          }
          break;
      }
    }
    const isValid = this.ErrorMsg.length === 0;
    if (!isValid) {
      this.toastService.error("Please fill in all required fields", "Validation Error");
    }

    return isValid;
  }

  onSubmit() {
    this.ErrorMsg = [];

    if (!this.validateForm()) return;
    const tempModal = new Cls_CenterData();
    tempModal.CompanyID = 1;
    tempModal.RegionID = this.centerData.RegionID;
    tempModal.AreaID = this.centerData.AreaID;
    tempModal.CityID = 0;
    tempModal.CenterName = this.centerData.CenterName;
    tempModal.Email = this.centerData.Email;
    tempModal.ContactNumber = this.centerData.ContactNumber;
    tempModal.AlternateNumber = this.centerData.AlternateNumber;
    tempModal.Address = this.centerData.Address;
    tempModal.District = this.centerData.District;
    tempModal.State = this.centerData.State;
    tempModal.Country = this.centerData.Country;
    tempModal.Pincode = this.centerData.Pincode;
    tempModal.MaxCapacity = this.centerData.MaxCapacity;
    tempModal.IsActive = true;

    if (this.centerData.CenterID && this.centerData.CenterID > 0) {
      this.masterService.updateCenter(tempModal, this.centerData.CenterID).subscribe(res => {
        this.toastService.success("Center updated successfully");
        this.router.navigate(["/center-select-page"]);
      });
    } else {
      this.masterService.addCenter(tempModal).subscribe(res => {
        this.toastService.success("Center added successfully");
        this.router.navigate(["/center-select-page"]);
      });
    }
  }

  onClose() {
    this.router.navigate(["/center-select-page"]);
  }

  updateDocuments(newDocs: DocumentObject[]): void {
    if (!newDocs || newDocs.length === 0) return;

    const category = newDocs[0].Category;

    if (!this.uploadedDocuments[category]) {
      this.uploadedDocuments[category] = [];
    }

    newDocs.forEach(doc => {
      const index = this.uploadedDocuments[category].findIndex(d => d.FileName === doc.FileName);

      if (index > -1) {
        // Merge new data with existing document
        this.uploadedDocuments[category][index] = {
          ...this.uploadedDocuments[category][index],
          ...doc,
        };
      } else {
        // Add new document
        this.uploadedDocuments[category].push(doc);
      }
    });
  }

  removeFile(docToRemove: DocumentObject): void {
    const category = docToRemove.Category;
    if (this.uploadedDocuments[category]) {
      this.uploadedDocuments[category] = this.uploadedDocuments[category].filter(doc => doc.FileName !== docToRemove.FileName);
    }
  }

  getAddressByPincode(pincode: string | undefined) {
    if (!pincode || pincode.length !== 6) return;

    this.http.get(`https://api.postalpincode.in/pincode/${pincode}`).subscribe({
      next: (response: any) => {
        if (response[0]?.Status === "Success") {
          const postOffice = response[0].PostOffice[0];
          this.centerData.District = postOffice.District;
          this.centerData.State = postOffice.State;
          this.centerData.Country = postOffice.Country;
        } else {
          this.centerData.District = "";
          this.centerData.State = "";
          this.centerData.Country = "";
        }
      },
      error: (err: any) => {
        console.error("Error fetching address:", err);
        this.centerData.District = "";
        this.centerData.State = "";
        this.centerData.Country = "";
      },
    });
  }

  ngOnDestroy() {
    this.globalService.setIsShowTrue();
  }
}
